module.exports = __webpack_public_path__ + "img/img3@2x.9b85e6ee.png";